import { type ErrorCodeMap } from './types';

export const onlineSessionErrorCodes: ErrorCodeMap = {
  ONLINE_SESSION_AUTH: 'desktop.errors.integration.sessionExpired',
  ONLINE_SESSION_HTTP: 'desktop.errors.integration.connectionFailed',
  // Emitted by both Rust upload pipelines when the connectivity probe has
  // already established there is no usable link, so the chunk is abandoned
  // without a request. Registered here so the code is a value the two sides
  // share rather than a string one side invents: the map-coverage suite in
  // `index.test.ts` walks every entry, so a rename on either side has to be a
  // deliberate edit to both. It resolves to the same key as a failed request
  // because, to a reader, it is the same outcome.
  ONLINE_SESSION_LINK_DOWN: 'desktop.errors.integration.connectionFailed',
  ONLINE_SESSION_NOT_CONFIGURED: 'desktop.errors.notConfigured',
  ONLINE_SESSION_DEVICE_ERROR: 'desktop.errors.audio.deviceError',
  ONLINE_SESSION_INTERNAL: 'desktop.errors.unknown',
};
